import { AudioAttachmentPlayer } from "@/components/tickets/AudioAttachmentPlayer";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useEffect, useMemo } from "react";

export function isLocalAudioFile(file: File): boolean {
  return (
    file.type.startsWith("audio/") ||
    /\.(webm|mp3|wav|m4a|ogg|opus|aac)$/i.test(file.name)
  );
}

export function PendingFileRow({
  file,
  onRemove,
}: {
  file: File;
  onRemove: () => void;
}) {
  const url = useMemo(() => URL.createObjectURL(file), [file]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  const showAudio = isLocalAudioFile(file);

  if (showAudio) {
    return (
      <li className="py-2 border-b border-border last:border-0">
        <div className="flex gap-2 items-start">
          <div className="min-w-0 flex-1">
            <AudioAttachmentPlayer src={url} label={file.name} compact />
          </div>
          <Button type="button" variant="ghost" size="sm" className="shrink-0" onClick={onRemove} aria-label="Remover">
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </li>
    );
  }

  return (
    <li className="flex flex-col gap-2 py-2 border-b border-border last:border-0">
      <div className="flex justify-between items-center gap-2">
        <span className="truncate text-sm">{file.name}</span>
        <Button type="button" variant="ghost" size="sm" onClick={onRemove} aria-label="Remover">
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </li>
  );
}
